enum LayoutSizes {
    MOBILE = 419,
    TABLET = 420,
    DESKTOP = 1025,
}

export default LayoutSizes;
